import { render, staticRenderFns } from "./DmTransactions.vue?vue&type=template&id=4420231f&scoped=true&"
import script from "./DmTransactions.vue?vue&type=script&lang=js&"
export * from "./DmTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4420231f",
  null
  
)

export default component.exports